/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Activity_Scoped_GenericInputs */



/**
* | output |
* | --- |
* | "Showing changes for one organization" |
*
* @param {Partner_Activity_Scoped_GenericInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_activity_scoped_generic = /** @type {((inputs?: Partner_Activity_Scoped_GenericInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Activity_Scoped_GenericInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Änderungen für eine Organisation")
	return /** @type {LocalizedString} */ ("Showing changes for one organization")
});